import React from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow,
  Polygon,
} from "react-google-maps";
import Container from "../../components/layouts/Container";
import { ContextLanguage } from "../../context/Context.Language";
import {
  TEXT_BANGKOK,
  TEXT_LAUNDRY_SERVICE_FOOTER,
  TEXT_PATTAYA,
  TEXT_SHOES_CLEANING,
} from "../../utils/useConstants";
import { useIsMobile } from "../../utils/useIsMobile";
import {
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_PADDING_WINDOWS,
  STYLE_TEXT_HEAD_GOOGLEMAP,
} from "../../utils/useStyle";

import { useWindowSize } from "../../utils/useWindowSize";

// const googleMapsKey = "AIzaSyBEfEiS-b6u12_-O2Ng_UeJlYLEOrWGOfA";
const googleMapsKey = "AIzaSyCBkCqnxwMUmT33843_vgeP1IXhxT1EVGE";
var googleMapURL = `https://maps.googleapis.com/maps/api/js?key=${googleMapsKey}&v=3.exp&libraries=geometry,drawing,places`;
const markerIcon = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAA0CAYAAADi1poDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAppJREFUeNrMWEuOozAQJUn3ZKZXHMGLrLLiCByBIzA34AjcgHVWzA2YA0QikUaa7Mh+FuQEgdUsppuudo0cyQLb2MFu8qQnlA/2c1XZVWXPswfizYiIMqesKEHAhrKkTFwK9SlTNhkYEsWFti1yj5A+C7awScgtCOm7M5BNthhxUal6GbHZbC7b7bZdr9ctfm6aJtjv961G7Hyn/GFimUK2SkII7Ha75nq9NiDB6XSq4zges1agKyYVDeD7PmRZBiao6xrCMFS5bzSmApmYqqrgXiisVYwJKm2L0RAVGlmnKAqwARrwEASBkZUGWxz9bxNlWcqsJIyl2pV1eEisFIuS4yB2XAB3qkAQesdbqrI1XYmTpCgZl/QFDXxI48eJINW4y94Omx28oEP/x7ZtnUx6uVy0BA1wPp+dCFKNywsa/OtwODix0vF4FOrUOodMk6kO8DgRbPtIJCgTlRp45NtCmqZGWZ+IjnVMijaACVpindy4ZM3z3FVihbHqksgKejT3vZZRiMl0NkIsKzsx+5vURrgIiZuA9XXaXYiy24ii6L8bsUQVlRhJkqiE3ALZuIm03QJptUJjSCyLqWy017FFMb6tEz95JDFTY2pSzIyhukNQ5LKGIoY3IZn3CdCNp9pF3Gh3uCYdqZNaXeNy6tOh2nWzXIISiZh8zs4lfxTryGKpfIT+rlZdGsyBhEsR1jrXKbh1vT+9B0Jtw11PE617I953/6L8TbmmfGcE9tTGylDEgi0CJ/1K+Y3xhfIv5R/2G/KZjX+7nAfdCUyAk3xhfOaeT9zi3ihfOf7j2Nl02aLHJfdcsbGAc1MneMdqDAFbPe+Cjn235HbsO/c9b6nOhcv4gF4x8oHt9SzUcQHuuRSkGgemDPQhwAC3qLvGM4GyJgAAAABJRU5ErkJggg==`;

const InfoConfirmContainer = ({ children }) => {
  return <div className="  w-auto p-2 ">{children}</div>;
};

const GoogleMapsWrapper = withScriptjs(
  withGoogleMap((props) => (
    <GoogleMap
      {...props}
      ref={(c) => {
        props.onMapMounted && props.onMapMounted(c);
      }}
    >
      {props.children}
    </GoogleMap>
  ))
);

const getMarker = ({ lat = 0, lng = 0, address }) => {
  const stepContactDetail = true;

  if (stepContactDetail) {
    return (
      <Marker
        icon={{
          url: markerIcon,
        }}
        position={{
          lat: Number(lat),
          lng: Number(lng),
        }}
      >
        <InfoWindow>
          <InfoConfirmContainer>
            <div
              className={`font-Poppins line-clamp-2 text-laundry-gray-100 font-semibold  `}
            >
              {address}
            </div>
          </InfoConfirmContainer>
        </InfoWindow>
      </Marker>
    );
  }

  return null;
};

const GoogleMapRender = ({
  size,
  isMobile,
  current,
  lineArray,
  zoom = 12,
  WidthMap,
  HeightMap,
  MarginMapLeft,
  MarginMapRight,
  MarginMapTop = isMobile ? "16px" : "-20px",
}) => {
  if (current) {
    return (
      <React.Fragment>
        <Container style="">
          <div className={`  `}>
            <div className={``}></div>
            <div
              style={{
                // width: isMobile ? "390px" : 0.78 * size.width,
                width: WidthMap,
                height: HeightMap,
                marginLeft: MarginMapLeft,
                marginRight: MarginMapRight,
                marginTop: MarginMapTop,
              }}
              className={``}
            >
              <GoogleMapsWrapper
                clickableIcons={false}
                isMarkerShown
                loadingElement={
                  <div style={{ height: `100%`, width: "100%" }} />
                }
                containerElement={
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                    }}
                  />
                }
                mapElement={
                  <div className="" style={{ height: `100%`, width: "100%" }} />
                }
                googleMapURL={googleMapURL}
                zoom={zoom}
                defaultCenter={{
                  lat: parseFloat(current.lat),
                  lng: parseFloat(current.lng),
                }}
                options={{
                  mapTypeControl: false,
                  panControl: false,
                  streetViewControl: false,
                  minZoom: 8,
                  maxZoom: 20,
                }}
              >
                {/* {getMarker({
                  lat: current?.lat,
                  lng: current?.lng,
                  address: current?.address,
                })} */}
                {/* <Polyline
                  path={lineArray}
                  geodesic={true}
                  options={{
                    strokeColor: "#ff2527",
                    strokeOpacity: 0.75,
                    strokeWeight: 2,
                    icons: [
                      {
                        offset: "0",
                        repeat: "20px",
                      },
                    ],
                  }}
                /> */}

                <Polygon
                  path={lineArray}
                  options={{
                    strokeColor: "#3AB4ED",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: "#3AB4ED",
                    fillOpacity: 0.5,
                  }}
                />
              </GoogleMapsWrapper>
              <div></div>
            </div>
          </div>
        </Container>
      </React.Fragment>
    );
  } else {
    return <React.Fragment />;
  }
};

// export const lineBangkok = [
//   { lat: 13.704586, lng: 100.485254 },
//   { lat: 13.73836, lng: 100.49806 },
//   { lat: 13.742662, lng: 100.49204 },
//   { lat: 13.751208, lng: 100.488296 },
//   { lat: 13.756377, lng: 100.48836 },
//   { lat: 13.761119, lng: 100.491115 },
//   { lat: 13.802054, lng: 100.517546 },
//   { lat: 13.813494, lng: 100.516925 },
//   { lat: 13.821575, lng: 100.526699 },
//   { lat: 13.820427, lng: 100.542327 },
//   { lat: 13.819245, lng: 100.546319 },
//   { lat: 13.822308, lng: 100.548969 },
//   { lat: 13.8282, lng: 100.551197 },
//   { lat: 13.831077, lng: 100.558005 },
//   { lat: 13.823769, lng: 100.573465 },
//   { lat: 13.80312, lng: 100.589542 },
//   { lat: 13.788888, lng: 100.590107 },
//   { lat: 13.779622, lng: 100.593631 },
//   { lat: 13.760409, lng: 100.595939 },
//   { lat: 13.75523, lng: 100.595338 },
//   { lat: 13.748891, lng: 100.603502 },
//   { lat: 13.724443, lng: 100.604321 },
//   { lat: 13.717129, lng: 100.601335 },
//   { lat: 13.709959, lng: 100.62154 },
//   { lat: 13.678119, lng: 100.630589 },
//   { lat: 13.678839, lng: 100.609115 },
//   { lat: 13.682609, lng: 100.590411 },
//   { lat: 13.691802, lng: 100.589509 },
//   { lat: 13.700688, lng: 100.581596 },
//   { lat: 13.707944, lng: 100.560184 },
//   { lat: 13.702524, lng: 100.549886 },
//   { lat: 13.677462, lng: 100.550913 },
//   { lat: 13.669111, lng: 100.539783 },
//   { lat: 13.692392, lng: 100.490776 },
//   { lat: 13.701116, lng: 100.491385 },
//   { lat: 13.704586, lng: 100.485254 },
// ];

export const centerPattaya = {
  lat: 12.93460666612908,
  lng: 100.90016744658749,
};

export const centerBangkok = {
  lat: 13.739636414745027,
  lng: 100.54520684825286,
};

// export const linePattaya = [
//   {
//     lat: 13.001069520430633,
//     lng: 100.92581963055949,
//   },
//   {
//     lat: 12.981592394550166,
//     lng: 100.93024291942943,
//   },
//   {
//     lat: 12.944785321517221,
//     lng: 100.91255713907445,
//   },
//   {
//     lat: 12.944638486727218,
//     lng: 100.92226359097353,
//   },
//   {
//     lat: 12.940743835174306,
//     lng: 100.92207434090268,
//   },
//   {
//     lat: 12.936147527975846,
//     lng: 100.93179047721299,
//   },
//   {
//     lat: 12.930076031904173,
//     lng: 100.93347628514728,
//   },
//   {
//     lat: 12.895143827951797,
//     lng: 100.92056991468164,
//   },
//   {
//     lat: 12.897205334379999,
//     lng: 100.91512139518846,
//   },
//   {
//     lat: 12.893056531133519,
//     lng: 100.90074501402589,
//   },
//   {
//     lat: 12.871972032460143,
//     lng: 100.90941237484252,
//   },
//   {
//     lat: 12.867624874654314,
//     lng: 100.89173140808262,
//   },
//   {
//     lat: 12.910050458594249,
//     lng: 100.85170393649128,
//   },
//   {
//     lat: 12.931424795522874,
//     lng: 100.86157285374185,
//   },
//   {
//     lat: 12.925903576902154,
//     lng: 100.8686968008854,
//   },
//   {
//     lat: 12.930319307026817,
//     lng: 100.87721070056362,
//   },
//   {
//     lat: 12.942212730598897,
//     lng: 100.88401377296968,
//   },
//   {
//     lat: 12.953243834157965,
//     lng: 100.88183245206042,
//   },
//   {
//     lat: 12.971252833294637,
//     lng: 100.88207445585003,
//   },
//   {
//     lat: 12.975793563768839,
//     lng: 100.89320000853691,
//   },
//   {
//     lat: 12.970733352594847,
//     lng: 100.89972314086113,
//   },
//   {
//     lat: 13.001069520430633,
//     lng: 100.92581963055949,
//   },
// ];

export const linePattaya = [
  { lat: 12.928238, lng: 100.875019 },
  { lat: 12.9306276, lng: 100.8778461 },
  { lat: 12.93331, lng: 100.880244 },
  { lat: 12.93331, lng: 100.880244 },
  { lat: 12.935568, lng: 100.881765 },
  { lat: 12.935568, lng: 100.881765 },
  { lat: 12.9395546, lng: 100.8836398 },
  { lat: 12.943834, lng: 100.88427 },
  { lat: 12.943834, lng: 100.88427 },
  { lat: 12.9471383, lng: 100.8844094 },
  { lat: 12.9491251, lng: 100.8841625 },
  { lat: 12.9535997, lng: 100.8818019 },
  { lat: 12.9544572, lng: 100.8822958 },
  { lat: 12.956444, lng: 100.882103 },
  { lat: 12.9568415, lng: 100.8828109 },
  { lat: 12.95795, lng: 100.882961 },
  { lat: 12.95795, lng: 100.882961 },
  { lat: 12.9574971, lng: 100.8833806 },
  { lat: 12.9580652, lng: 100.8841697 },
  { lat: 12.9591858, lng: 100.8846501 },
  { lat: 12.9635893, lng: 100.884122 },
  { lat: 12.9635893, lng: 100.884122 },
  { lat: 12.9662599, lng: 100.8834816 },
  { lat: 12.967867, lng: 100.8825498 },
  { lat: 12.9683359, lng: 100.8826418 },
  { lat: 12.9682777, lng: 100.8829453 },
  { lat: 12.9695032, lng: 100.8829897 },
  { lat: 12.9697814, lng: 100.8826472 },
  { lat: 12.9703941, lng: 100.882884 },
  { lat: 12.9708856, lng: 100.8832168 },
  { lat: 12.970964, lng: 100.8838124 },
  { lat: 12.9714633, lng: 100.8844964 },
  { lat: 12.9710856, lng: 100.8848385 },
  { lat: 12.9711477, lng: 100.8853742 },
  { lat: 12.9708859, lng: 100.8858567 },
  { lat: 12.9712778, lng: 100.8864627 },
  { lat: 12.972254, lng: 100.887494 },
  { lat: 12.9721357, lng: 100.8878594 },
  { lat: 12.9725784, lng: 100.8885571 },
  { lat: 12.9730925, lng: 100.8886914 },
  { lat: 12.9736902, lng: 100.8883536 },
  { lat: 12.973851, lng: 100.8890845 },
  { lat: 12.9736595, lng: 100.8893427 },
  { lat: 12.9733546, lng: 100.8896219 },
  { lat: 12.9727422, lng: 100.8896328 },
  { lat: 12.9725614, lng: 100.8901318 },
  { lat: 12.9729938, lng: 100.8911538 },
  { lat: 12.9746109, lng: 100.8926089 },
  { lat: 12.9753708, lng: 100.8927122 },
  { lat: 12.9743877, lng: 100.894107 },
  { lat: 12.973708, lng: 100.8946327 },
  { lat: 12.9733472, lng: 100.8950457 },
  { lat: 12.9729786, lng: 100.8946943 },
  { lat: 12.9723134, lng: 100.8949478 },
  { lat: 12.972148, lng: 100.8975207 },
  { lat: 12.9718572, lng: 100.8977332 },
  { lat: 12.9718572, lng: 100.8977332 },
  { lat: 12.9712967, lng: 100.897675 },
  { lat: 12.97087, lng: 100.8979463 },
  { lat: 12.9709285, lng: 100.8983609 },
  { lat: 12.9704977, lng: 100.8985253 },
  { lat: 12.9705541, lng: 100.8992083 },
  { lat: 12.9704151, lng: 100.8995069 },
  { lat: 12.9713074, lng: 100.9020165 },
  { lat: 12.9725063, lng: 100.9032499 },
  { lat: 12.9733358, lng: 100.9041241 },
  { lat: 12.9731441, lng: 100.9043252 },
  { lat: 12.9761726, lng: 100.9066935 },
  { lat: 12.9761726, lng: 100.9066935 },
  { lat: 12.9765093, lng: 100.9081132 },
  { lat: 12.9773886, lng: 100.9095097 },
  { lat: 12.9788737, lng: 100.9108089 },
  { lat: 12.9792817, lng: 100.9118876 },
  { lat: 12.9820785, lng: 100.9141436 },
  { lat: 12.9830169, lng: 100.915143 },
  { lat: 12.985577, lng: 100.9175309 },
  { lat: 12.988237, lng: 100.919712 },
  { lat: 12.9922851, lng: 100.9219184 },
  { lat: 12.9962078, lng: 100.9229232 },
  { lat: 12.9975253, lng: 100.9235024 },
  { lat: 12.9974313, lng: 100.92435 },
  { lat: 13.0021462, lng: 100.9257554 },
  { lat: 12.995497, lng: 100.933609 },
  { lat: 12.995497, lng: 100.933609 },
  { lat: 12.981677, lng: 100.93026 },
  { lat: 12.973104, lng: 100.926569 },
  { lat: 12.973104, lng: 100.926569 },
  { lat: 12.944881, lng: 100.912503 },
  { lat: 12.944881, lng: 100.912503 },
  { lat: 12.944938, lng: 100.92255 },
  { lat: 12.941132, lng: 100.922164 },
  { lat: 12.938288, lng: 100.927271 },
  { lat: 12.938288, lng: 100.927271 },
  { lat: 12.936215, lng: 100.931668 },
  { lat: 12.930171, lng: 100.933492 },
  { lat: 12.921429, lng: 100.930423 },
  { lat: 12.921429, lng: 100.930423 },
  { lat: 12.894829, lng: 100.921143 },
  { lat: 12.897172, lng: 100.915478 },
  { lat: 12.893239, lng: 100.901059 },
  { lat: 12.873075, lng: 100.909298 },
  { lat: 12.873075, lng: 100.909298 },
  { lat: 12.8675825, lng: 100.8915183 },
  { lat: 12.8675825, lng: 100.8915183 },
  { lat: 12.8785181, lng: 100.8836357 },
  { lat: 12.8888364, lng: 100.8755057 },
  { lat: 12.8930856, lng: 100.871537 },
  { lat: 12.8973766, lng: 100.8674395 },
  { lat: 12.9059165, lng: 100.859201 },
  { lat: 12.906485, lng: 100.8592072 },
  { lat: 12.9083293, lng: 100.857561 },
  { lat: 12.9099227, lng: 100.8556143 },
  { lat: 12.9103777, lng: 100.8558935 },
  { lat: 12.9105922, lng: 100.8559045 },
  { lat: 12.9109794, lng: 100.8560337 },
  { lat: 12.9110949, lng: 100.8558845 },
  { lat: 12.9113678, lng: 100.856144 },
  { lat: 12.9128965, lng: 100.8567489 },
  { lat: 12.9131723, lng: 100.8565638 },
  { lat: 12.9138284, lng: 100.8571807 },
  { lat: 12.9143041, lng: 100.8572988 },
  { lat: 12.9151508, lng: 100.8568053 },
  { lat: 12.9167194, lng: 100.8558822 },
  { lat: 12.9175455, lng: 100.8563434 },
  { lat: 12.9185442, lng: 100.8558016 },
  { lat: 12.9192945, lng: 100.8561315 },
  { lat: 12.9196906, lng: 100.855996 },
  { lat: 12.9199096, lng: 100.8560999 },
  { lat: 12.9199145, lng: 100.8564094 },
  { lat: 12.9198567, lng: 100.8567403 },
  { lat: 12.9197, lng: 100.8571158 },
  { lat: 12.9197263, lng: 100.8574538 },
  { lat: 12.9201159, lng: 100.8580519 },
  { lat: 12.9209172, lng: 100.8586943 },
  { lat: 12.9219662, lng: 100.8590799 },
  { lat: 12.9228881, lng: 100.8589937 },
  { lat: 12.9236419, lng: 100.8588863 },
  { lat: 12.9245625, lng: 100.8586609 },
  { lat: 12.9251274, lng: 100.8590846 },
  { lat: 12.924887, lng: 100.8595754 },
  { lat: 12.9248923, lng: 100.8601212 },
  { lat: 12.9253341, lng: 100.8605229 },
  { lat: 12.9260779, lng: 100.8608954 },
  { lat: 12.9280183, lng: 100.861425 },
  { lat: 12.9284657, lng: 100.861325 },
  { lat: 12.9292685, lng: 100.8616541 },
  { lat: 12.9292685, lng: 100.8616541 },
  { lat: 12.9304312, lng: 100.8622297 },
  { lat: 12.9293856, lng: 100.863217 },
  { lat: 12.9283608, lng: 100.8637321 },
  { lat: 12.9281831, lng: 100.8640969 },
  { lat: 12.9279478, lng: 100.8640862 },
  { lat: 12.9265753, lng: 100.8648748 },
  { lat: 12.9260603, lng: 100.8659638 },
  { lat: 12.9257574, lng: 100.8671009 },
  { lat: 12.9257941, lng: 100.8679699 },
  { lat: 12.9252871, lng: 100.8681308 },
  { lat: 12.9255286, lng: 100.8699012 },
  { lat: 12.928238, lng: 100.875019 },
];

// export const lineBangkok = [
//   { lat: 13.700443, lng: 100.582108 },
//   { lat: 13.6961563, lng: 100.5860911 },
//   { lat: 13.6918278, lng: 100.5895591 },
//   { lat: 13.6914683, lng: 100.5894141 },
//   { lat: 13.6902489, lng: 100.5903686 },
//   { lat: 13.685433, lng: 100.590948 },
//   { lat: 13.682097, lng: 100.590304 },
//   { lat: 13.682097, lng: 100.590304 },
//   { lat: 13.678621, lng: 100.608429 },
//   { lat: 13.677662, lng: 100.631646 },
//   { lat: 13.685668, lng: 100.632462 },
//   { lat: 13.700637, lng: 100.62684 },
//   { lat: 13.700637, lng: 100.62684 },
//   { lat: 13.709309, lng: 100.621862 },
//   { lat: 13.715479, lng: 100.607528 },
//   { lat: 13.715479, lng: 100.607528 },
//   { lat: 13.718562, lng: 100.601835 },
//   { lat: 13.724357, lng: 100.604453 },
//   { lat: 13.735697, lng: 100.60338 },
//   { lat: 13.735697, lng: 100.60338 },
//   { lat: 13.747228, lng: 100.604383 },
//   { lat: 13.749312, lng: 100.60361 },
//   { lat: 13.752438, lng: 100.598117 },
//   { lat: 13.756815, lng: 100.594255 },
//   { lat: 13.756815, lng: 100.594255 },
//   { lat: 13.760024, lng: 100.595537 },
//   { lat: 13.775113, lng: 100.594207 },
//   { lat: 13.779615, lng: 100.594035 },
//   { lat: 13.783824, lng: 100.592233 },
//   { lat: 13.789868, lng: 100.590301 },
//   { lat: 13.793785, lng: 100.589829 },
//   { lat: 13.793785, lng: 100.589829 },
//   { lat: 13.803038, lng: 100.589143 },
//   { lat: 13.823291, lng: 100.574981 },
//   { lat: 13.827959, lng: 100.569659 },
//   { lat: 13.827959, lng: 100.569659 },
//   { lat: 13.831224, lng: 100.560116 },
//   { lat: 13.829224, lng: 100.553164 },
//   { lat: 13.826141, lng: 100.549645 },
//   { lat: 13.822557, lng: 100.548872 },
//   { lat: 13.820056, lng: 100.550332 },
//   { lat: 13.819306, lng: 100.547327 },
//   { lat: 13.820723, lng: 100.542607 },
//   { lat: 13.821807, lng: 100.534195 },
//   { lat: 13.82164, lng: 100.524411 },
//   { lat: 13.815222, lng: 100.517201 },
//   { lat: 13.81393, lng: 100.5161928 },
//   { lat: 13.8122526, lng: 100.5173757 },
//   { lat: 13.8104502, lng: 100.5181508 },
//   { lat: 13.8085956, lng: 100.5186283 },
//   { lat: 13.806887, lng: 100.5186819 },
//   { lat: 13.80522, lng: 100.518918 },
//   { lat: 13.803277, lng: 100.5186495 },
//   { lat: 13.8008547, lng: 100.5179734 },
//   { lat: 13.7975729, lng: 100.5167713 },
//   { lat: 13.7960777, lng: 100.5159627 },
//   { lat: 13.7945617, lng: 100.5150038 },
//   { lat: 13.7935926, lng: 100.5141376 },
//   { lat: 13.7921963, lng: 100.5127484 },
//   { lat: 13.7909041, lng: 100.5115794 },
//   { lat: 13.7896303, lng: 100.5105681 },
//   { lat: 13.7883773, lng: 100.5094067 },
//   { lat: 13.7882262, lng: 100.5089506 },
//   { lat: 13.7873822, lng: 100.5082745 },
//   { lat: 13.7856316, lng: 100.5066864 },
//   { lat: 13.783631, lng: 100.50527 },
//   { lat: 13.7803854, lng: 100.5035213 },
//   { lat: 13.7775982, lng: 100.5022876 },
//   { lat: 13.7771506, lng: 100.5026096 },
//   { lat: 13.7749624, lng: 100.5018157 },
//   { lat: 13.773837, lng: 100.5011505 },
//   { lat: 13.7720863, lng: 100.5002064 },
//   { lat: 13.7695437, lng: 100.4990048 },
//   { lat: 13.7678764, lng: 100.4978462 },
//   { lat: 13.7665738, lng: 100.4967519 },
//   { lat: 13.7648543, lng: 100.4954859 },
//   { lat: 13.763708, lng: 100.4940697 },
//   { lat: 13.76054, lng: 100.490937 },
//   { lat: 13.76054, lng: 100.490937 },
//   { lat: 13.754487, lng: 100.487718 },
//   { lat: 13.7473165, lng: 100.4894566 },
//   { lat: 13.7450917, lng: 100.4908188 },
//   { lat: 13.7433463, lng: 100.4921595 },
//   { lat: 13.7429424, lng: 100.492641 },
//   { lat: 13.7428408, lng: 100.4929509 },
//   { lat: 13.7423041, lng: 100.4933559 },
//   { lat: 13.7416996, lng: 100.4941553 },
//   { lat: 13.7405428, lng: 100.4961511 },
//   { lat: 13.7401989, lng: 100.4971491 },
//   { lat: 13.7402874, lng: 100.4973048 },
//   { lat: 13.7401129, lng: 100.4977903 },
//   { lat: 13.7399839, lng: 100.4982584 },
//   { lat: 13.7397944, lng: 100.4988357 },
//   { lat: 13.7390743, lng: 100.4983948 },
//   { lat: 13.7383959, lng: 100.4977287 },
//   { lat: 13.7363324, lng: 100.4963068 },
//   { lat: 13.7274738, lng: 100.493383 },
//   { lat: 13.70446, lng: 100.485143 },
//   { lat: 13.70446, lng: 100.485143 },
//   { lat: 13.6996475, lng: 100.4932307 },
//   { lat: 13.6986504, lng: 100.4920407 },
//   { lat: 13.6966109, lng: 100.4912797 },
//   { lat: 13.6964721, lng: 100.4910454 },
//   { lat: 13.6957359, lng: 100.4909629 },
//   { lat: 13.6954727, lng: 100.4911413 },
//   { lat: 13.6948628, lng: 100.4911547 },
//   { lat: 13.6946855, lng: 100.491439 },
//   { lat: 13.6941641, lng: 100.4915355 },
//   { lat: 13.6936633, lng: 100.491557 },
//   { lat: 13.6927983, lng: 100.4921255 },
//   { lat: 13.6908076, lng: 100.4943248 },
//   { lat: 13.690519, lng: 100.4948357 },
//   { lat: 13.690418, lng: 100.4956256 },
//   { lat: 13.6899659, lng: 100.4963901 },
//   { lat: 13.6895619, lng: 100.4967173 },
//   { lat: 13.6892544, lng: 100.4975863 },
//   { lat: 13.6880555, lng: 100.5012554 },
//   { lat: 13.6878675, lng: 100.5027143 },
//   { lat: 13.6878428, lng: 100.5032964 },
//   { lat: 13.6879015, lng: 100.5037926 },
//   { lat: 13.6876852, lng: 100.5044417 },
//   { lat: 13.6876696, lng: 100.5059974 },
//   { lat: 13.68743, lng: 100.5074351 },
//   { lat: 13.6871175, lng: 100.5088514 },
//   { lat: 13.687038, lng: 100.5093414 },
//   { lat: 13.6872086, lng: 100.5100889 },
//   { lat: 13.6869661, lng: 100.5107685 },
//   { lat: 13.6868146, lng: 100.5112265 },
//   { lat: 13.6865116, lng: 100.5114988 },
//   { lat: 13.6865729, lng: 100.5123007 },
//   { lat: 13.6867371, lng: 100.5130464 },
//   { lat: 13.6863566, lng: 100.5138081 },
//   { lat: 13.6860125, lng: 100.5152028 },
//   { lat: 13.6852828, lng: 100.5168763 },
//   { lat: 13.6845531, lng: 100.5183294 },
//   { lat: 13.6838651, lng: 100.5193105 },
//   { lat: 13.6827393, lng: 100.5211009 },
//   { lat: 13.6807378, lng: 100.5236518 },
//   { lat: 13.6792784, lng: 100.5252773 },
//   { lat: 13.6784653, lng: 100.5259962 },
//   { lat: 13.6757575, lng: 100.5293169 },
//   { lat: 13.6754265, lng: 100.5291828 },
//   { lat: 13.6733259, lng: 100.5314465 },
//   { lat: 13.6717515, lng: 100.5338282 },
//   { lat: 13.6715691, lng: 100.5343405 },
//   { lat: 13.6711156, lng: 100.5350244 },
//   { lat: 13.6706673, lng: 100.5362636 },
//   { lat: 13.6703961, lng: 100.5402009 },
//   { lat: 13.670688, lng: 100.5413194 },
//   { lat: 13.6709382, lng: 100.5422877 },
//   { lat: 13.6712719, lng: 100.5433659 },
//   { lat: 13.6718141, lng: 100.5446212 },
//   { lat: 13.6747333, lng: 100.5477755 },
//   { lat: 13.676555, lng: 100.5487599 },
//   { lat: 13.6782933, lng: 100.5494439 },
//   { lat: 13.6800185, lng: 100.5502969 },
//   { lat: 13.6820096, lng: 100.5508013 },
//   { lat: 13.6833869, lng: 100.5508228 },
//   { lat: 13.685202, lng: 100.5510159 },
//   { lat: 13.6873728, lng: 100.5510374 },
//   { lat: 13.6889625, lng: 100.550694 },
//   { lat: 13.6894734, lng: 100.5507369 },
//   { lat: 13.6910788, lng: 100.5501788 },
//   { lat: 13.6933942, lng: 100.5497644 },
//   { lat: 13.695501, lng: 100.5493071 },
//   { lat: 13.6983805, lng: 100.5494654 },
//   { lat: 13.6999701, lng: 100.5494385 },
//   { lat: 13.7011061, lng: 100.5496423 },
//   { lat: 13.7039191, lng: 100.5510209 },
//   { lat: 13.7045849, lng: 100.5516915 },
//   { lat: 13.7056663, lng: 100.5527322 },
//   { lat: 13.70662, lng: 100.5542558 },
//   { lat: 13.706818, lng: 100.5552001 },
//   { lat: 13.7075058, lng: 100.5561875 },
//   { lat: 13.7078094, lng: 100.5576225 },
//   { lat: 13.7077378, lng: 100.559315 },
//   { lat: 13.7079698, lng: 100.5610691 },
//   { lat: 13.7073498, lng: 100.56329 },
//   { lat: 13.7067351, lng: 100.566058 },
//   { lat: 13.7059742, lng: 100.5686168 },
//   { lat: 13.7051925, lng: 100.5710896 },
//   { lat: 13.7040876, lng: 100.5745763 },
//   { lat: 13.7040876, lng: 100.5745763 },
//   { lat: 13.7036738, lng: 100.5753219 },
//   { lat: 13.702968, lng: 100.5770332 },
//   { lat: 13.701765, lng: 100.5795545 },
//   { lat: 13.700443, lng: 100.582108 },
// ];

export const lineBangkok = [
  {
    lat: 13.7065275,
    lng: 100.5668389,
  },
  {
    lat: 13.704693,
    lng: 100.5722892,
  },
  {
    lat: 13.7032754,
    lng: 100.5762803,
  },
  {
    lat: 13.7032754,
    lng: 100.5762803,
  },
  {
    lat: 13.7016076,
    lng: 100.5798423,
  },
  {
    lat: 13.7000232,
    lng: 100.5827176,
  },
  {
    lat: 13.6978551,
    lng: 100.5848205,
  },
  {
    lat: 13.6948114,
    lng: 100.5873954,
  },
  {
    lat: 13.691434,
    lng: 100.5898845,
  },
  {
    lat: 13.6876814,
    lng: 100.5908286,
  },
  {
    lat: 13.6839704,
    lng: 100.5910003,
  },
  {
    lat: 13.6825944,
    lng: 100.5905282,
  },
  {
    lat: 13.6825944,
    lng: 100.5905282,
  },
  {
    lat: 13.6782069,
    lng: 100.5888395,
  },
  {
    lat: 13.6739953,
    lng: 100.5859642,
  },
  {
    lat: 13.6680323,
    lng: 100.5816727,
  },
  {
    lat: 13.6618606,
    lng: 100.5971436,
  },
  {
    lat: 13.6618606,
    lng: 100.5971436,
  },
  {
    lat: 13.6464564,
    lng: 100.6384539,
  },
  {
    lat: 13.6531706,
    lng: 100.642445,
  },
  {
    lat: 13.6605102,
    lng: 100.6436896,
  },
  {
    lat: 13.6688503,
    lng: 100.6452775,
  },
  {
    lat: 13.6746048,
    lng: 100.6462645,
  },
  {
    lat: 13.6775237,
    lng: 100.6464791,
  },
  {
    lat: 13.6775237,
    lng: 100.6464791,
  },
  {
    lat: 13.6958772,
    lng: 100.6480818,
  },
  {
    lat: 13.6992962,
    lng: 100.6475668,
  },
  {
    lat: 13.7037575,
    lng: 100.646451,
  },
  {
    lat: 13.7037575,
    lng: 100.646451,
  },
  {
    lat: 13.7185724,
    lng: 100.6431156,
  },
  {
    lat: 13.727911,
    lng: 100.6422144,
  },
  {
    lat: 13.7332889,
    lng: 100.6416565,
  },
  {
    lat: 13.7332889,
    lng: 100.6416565,
  },
  {
    lat: 13.7357406,
    lng: 100.6415761,
  },
  {
    lat: 13.7415769,
    lng: 100.6433785,
  },
  {
    lat: 13.7535407,
    lng: 100.646211,
  },
  {
    lat: 13.7573757,
    lng: 100.6467689,
  },
  {
    lat: 13.7659208,
    lng: 100.6458676,
  },
  {
    lat: 13.7659208,
    lng: 100.6458676,
  },
  {
    lat: 13.7660072,
    lng: 100.6483133,
  },
  {
    lat: 13.7725929,
    lng: 100.6477554,
  },
  {
    lat: 13.7751772,
    lng: 100.6458671,
  },
  {
    lat: 13.7791368,
    lng: 100.6447942,
  },
  {
    lat: 13.7869726,
    lng: 100.6501157,
  },
  {
    lat: 13.7918073,
    lng: 100.653549,
  },
  {
    lat: 13.7918073,
    lng: 100.653549,
  },
  {
    lat: 13.8040186,
    lng: 100.6478412,
  },
  {
    lat: 13.8102282,
    lng: 100.6509311,
  },
  {
    lat: 13.8102282,
    lng: 100.6509311,
  },
  {
    lat: 13.8156372,
    lng: 100.6435068,
  },
  {
    lat: 13.8186376,
    lng: 100.6381853,
  },
  {
    lat: 13.8212214,
    lng: 100.6340654,
  },
  {
    lat: 13.8258887,
    lng: 100.6288297,
  },
  {
    lat: 13.8258887,
    lng: 100.6288297,
  },
  {
    lat: 13.8304524,
    lng: 100.623833,
  },
  {
    lat: 13.8324526,
    lng: 100.6146491,
  },
  {
    lat: 13.84212,
    lng: 100.5967964,
  },
  {
    lat: 13.8426201,
    lng: 100.5896724,
  },
  {
    lat: 13.8414533,
    lng: 100.5799736,
  },
  {
    lat: 13.8407033,
    lng: 100.5764545,
  },
  {
    lat: 13.8479536,
    lng: 100.5628932,
  },
  {
    lat: 13.8498703,
    lng: 100.5590309,
  },
  {
    lat: 13.8498703,
    lng: 100.5590309,
  },
  {
    lat: 13.8498703,
    lng: 100.5590309,
  },
  {
    lat: 13.8568341,
    lng: 100.5462422,
  },
  {
    lat: 13.8572507,
    lng: 100.5444398,
  },
  {
    lat: 13.8314995,
    lng: 100.5383458,
  },
  {
    lat: 13.8309161,
    lng: 100.5296769,
  },
  {
    lat: 13.8249988,
    lng: 100.5235829,
  },
  {
    lat: 13.8170809,
    lng: 100.5146565,
  },
  {
    lat: 13.8102464,
    lng: 100.509335,
  },
  {
    lat: 13.8102464,
    lng: 100.509335,
  },
  {
    lat: 13.8077299,
    lng: 100.5101575,
  },
  {
    lat: 13.8041458,
    lng: 100.5068101,
  },
  {
    lat: 13.7998115,
    lng: 100.5016602,
  },
  {
    lat: 13.7964773,
    lng: 100.4920472,
  },
  {
    lat: 13.7933932,
    lng: 100.4845799,
  },
  {
    lat: 13.7910592,
    lng: 100.4781426,
  },
  {
    lat: 13.7877249,
    lng: 100.4694737,
  },
  {
    lat: 13.7813063,
    lng: 100.4505052,
  },
  // {
  //   lat: 13.7065275,
  //   lng: 100.5668389,
  // },
  // {
  //   lat: 13.7065275,
  //   lng: 100.5668389,
  // },
  // {
  //   lat: 13.7081872,
  //   lng: 100.557471,
  // },
  // {
  //   lat: 13.703184,
  //   lng: 100.5509479,
  // },
  // {
  //   lat: 13.6981807,
  //   lng: 100.5490596,
  // },
  // {
  //   lat: 13.6921766,
  //   lng: 100.5500896,
  // },
  // {
  //   lat: 13.6850048,
  //   lng: 100.5509479,
  // },
  // {
  //   lat: 13.677666,
  //   lng: 100.5497462,
  // },
  // {
  //   lat: 13.6718282,
  //   lng: 100.5444247,
  // },
  // {
  //   lat: 13.670327,
  //   lng: 100.5394466,
  // },
  // {
  //   lat: 13.6718282,
  //   lng: 100.5329234,
  // },
  // {
  //   lat: 13.676832,
  //   lng: 100.526572,
  // },
  // {
  //   lat: 13.6815022,
  //   lng: 100.5221088,
  // },
  // {
  //   lat: 13.6858387,
  //   lng: 100.5162723,
  // },
  // {
  //   lat: 13.6873398,
  //   lng: 100.5087192,
  // },
  // {
  //   lat: 13.6886741,
  //   lng: 100.4989345,
  // },
  // {
  //   lat: 13.6920098,
  //   lng: 100.4927547,
  // },
  // {
  //   lat: 13.6966797,
  //   lng: 100.4906947,
  // },
  // {
  //   lat: 13.7008491,
  //   lng: 100.4929263,
  // },
  // {
  //   lat: 13.7005156,
  //   lng: 100.4926689,
  // },
  // {
  //   lat: 13.7043931,
  //   lng: 100.4845579,
  // },
  // {
  //   lat: 13.7083123,
  //   lng: 100.4800088,
  // },
  // {
  //   lat: 13.7113558,
  //   lng: 100.478378,
  // },
  // {
  //   lat: 13.7146078,
  //   lng: 100.4781206,
  // },
  // {
  //   lat: 13.7128151,
  //   lng: 100.4751594,
  // },
  // {
  //   lat: 13.7119812,
  //   lng: 100.4731853,
  // },
  // {
  //   lat: 13.7119812,
  //   lng: 100.4731853,
  // },
  // {
  //   lat: 13.7122341,
  //   lng: 100.4700921,
  // },
  // {
  //   lat: 13.7137141,
  //   lng: 100.4665301,
  // },
  // {
  //   lat: 13.7141102,
  //   lng: 100.4648778,
  // },
  // {
  //   lat: 13.714402,
  //   lng: 100.4616377,
  // },
  // {
  //   lat: 13.7154443,
  //   lng: 100.4593847,
  // },
  // {
  //   lat: 13.7180709,
  //   lng: 100.4578826,
  // },
  // {
  //   lat: 13.720218,
  //   lng: 100.4576037,
  // },
  // {
  //   lat: 13.720218,
  //   lng: 100.4576037,
  // },
  // {
  //   lat: 13.7241831,
  //   lng: 100.4563709,
  // },
  // {
  //   lat: 13.7281436,
  //   lng: 100.4528089,
  // },
  // {
  //   lat: 13.7323542,
  //   lng: 100.4491182,
  // },
  // {
  //   lat: 13.7368149,
  //   lng: 100.4471011,
  // },
  // {
  //   lat: 13.7414839,
  //   lng: 100.4464145,
  // },
  // {
  //   lat: 13.7414839,
  //   lng: 100.4464145,
  // },
  // {
  //   lat: 13.7473617,
  //   lng: 100.4468007,
  // },
  // {
  //   lat: 13.7534477,
  //   lng: 100.4453416,
  // },
  // {
  //   lat: 13.7690373,
  //   lng: 100.44311,
  // },
  // {
  //   lat: 13.7790408,
  //   lng: 100.44208,
  // },
  // {
  //   lat: 13.7813063,
  //   lng: 100.4505052,
  // },

  {
    lat: 13.7813063,
    lng: 100.4505052,
  },
  {
    lat: 13.7790408,
    lng: 100.44208,
  },
  {
    lat: 13.7690373,
    lng: 100.44311,
  },
  {
    lat: 13.7534477,
    lng: 100.4453416,
  },
  {
    lat: 13.7473617,
    lng: 100.4468007,
  },
  {
    lat: 13.7414839,
    lng: 100.4464145,
  },
  {
    lat: 13.7414839,
    lng: 100.4464145,
  },
  {
    lat: 13.7368149,
    lng: 100.4471011,
  },
  {
    lat: 13.7323542,
    lng: 100.4491182,
  },
  {
    lat: 13.7281436,
    lng: 100.4528089,
  },
  {
    lat: 13.7241831,
    lng: 100.4563709,
  },
  {
    lat: 13.720218,
    lng: 100.4576037,
  },
  {
    lat: 13.720218,
    lng: 100.4576037,
  },
  {
    lat: 13.7180709,
    lng: 100.4578826,
  },
  {
    lat: 13.7154443,
    lng: 100.4593847,
  },
  {
    lat: 13.714402,
    lng: 100.4616377,
  },
  {
    lat: 13.7141102,
    lng: 100.4648778,
  },
  {
    lat: 13.7137141,
    lng: 100.4665301,
  },
  {
    lat: 13.7122341,
    lng: 100.4700921,
  },
  {
    lat: 13.7119812,
    lng: 100.4731853,
  },
  {
    lat: 13.7119812,
    lng: 100.4731853,
  },
  {
    lat: 13.7128151,
    lng: 100.4751594,
  },
  {
    lat: 13.7146078,
    lng: 100.4781206,
  },
  {
    lat: 13.7113558,
    lng: 100.478378,
  },
  {
    lat: 13.7083123,
    lng: 100.4800088,
  },
  {
    lat: 13.7043931,
    lng: 100.4845579,
  },
  {
    lat: 13.7005156,
    lng: 100.4926689,
  },
  {
    lat: 13.7008491,
    lng: 100.4929263,
  },
  {
    lat: 13.6966797,
    lng: 100.4906947,
  },
  {
    lat: 13.6920098,
    lng: 100.4927547,
  },
  {
    lat: 13.6886741,
    lng: 100.4989345,
  },
  {
    lat: 13.6873398,
    lng: 100.5087192,
  },
  {
    lat: 13.6858387,
    lng: 100.5162723,
  },
  {
    lat: 13.6815022,
    lng: 100.5221088,
  },
  {
    lat: 13.676832,
    lng: 100.526572,
  },
  {
    lat: 13.6718282,
    lng: 100.5329234,
  },
  {
    lat: 13.670327,
    lng: 100.5394466,
  },
  {
    lat: 13.6718282,
    lng: 100.5444247,
  },
  {
    lat: 13.677666,
    lng: 100.5497462,
  },
  {
    lat: 13.6850048,
    lng: 100.5509479,
  },
  {
    lat: 13.6921766,
    lng: 100.5500896,
  },
  {
    lat: 13.6981807,
    lng: 100.5490596,
  },
  {
    lat: 13.703184,
    lng: 100.5509479,
  },
  {
    lat: 13.7081872,
    lng: 100.557471,
  },
  {
    lat: 13.7065275,
    lng: 100.5668389,
  },
  {
    lat: 13.7065275,
    lng: 100.5668389,
  },
];

export const GoogleMapMain = () => {
  const size = useWindowSize();
  const isMobile = useIsMobile();
  const { language } = React.useContext(ContextLanguage);
  // const [current, setCurrent] = React.useState(false);

  // React.useEffect(() => {
  //   FunctionGetCurrentLocation(setCurrent);
  //   return () => {};
  // }, [setCurrent]);

  return (
    <div className={`${STYLE_MAX_WIDTH_DESKTOP} `}>
      <div
        className={`w-full h-full mt-10 md:mt-13.5 pb-10 ${STYLE_PADDING_WINDOWS} grid md:grid-cols-2 gap-6`}
      >
        <div>
          <div className={STYLE_TEXT_HEAD_GOOGLEMAP(language)}>
            {TEXT_BANGKOK[language]}
          </div>
          <div
            className={`${
              language === "TH"
                ? " text-base-th md:text-lg-th "
                : " text-base md:text-lg "
            } text-laundry-gray-200 leading-6 my-1.5`}
          >
            {TEXT_LAUNDRY_SERVICE_FOOTER[language]}|
            {TEXT_SHOES_CLEANING[language]}
          </div>
          <div
          // style={{
          //   width: "563px",
          //   height: "395px",
          // }}
          >
            <GoogleMapRender
              current={centerBangkok}
              isMobile={isMobile}
              WidthMap="100%"
              HeightMap={isMobile ? "395px" : "432px"}
              MarginMapTop=" 19px"
              size={size}
              lineArray={lineBangkok}
              zoom={11}
            />
          </div>
        </div>
        <div>
          <div className={STYLE_TEXT_HEAD_GOOGLEMAP(language)}>
            {TEXT_PATTAYA[language]}{" "}
            {language === "TH"
              ? "(เปิดโฉมใหม่ 01.12.2023)"
              : "(Re-Opening 01.12.2023)"}
          </div>
          <div
            className={`${
              language === "TH"
                ? " text-base-th md:text-lg-th  "
                : " text-base md:text-lg  "
            } text-laundry-gray-200 leading-6 my-1.5`}
          >
            {/* {TEXT_LAUNDRY_SERVICE_FOOTER[language]}| */}
            {/* {TEXT_SHOES_CLEANING[language]} */}
            {/* <div>
              {language === "TH" ? "" : "Pattaya (Re-Opening 01.09.2023)"}
            </div> */}
            <div>
              {language === "TH"
                ? "เรากำลังยกระดับสิ่งอำนวยความสะดวกเพื่อคุณ"
                : "We are upgrading our facilities for you!"}
            </div>
          </div>
          <GoogleMapRender
            current={centerPattaya}
            isMobile={isMobile}
            WidthMap="100%"
            HeightMap="432px"
            MarginMapTop=" 19px"
            size={size}
            zoom={12}
            lineArray={linePattaya}
          />
        </div>
      </div>
    </div>
  );
};
